import PageContainer                         from "@/components/pageContainer/PageContainer";
import PageTitle                             from "@/components/pageTitle/PageTitle";
import Spinner                               from "@/components/spinner/Spinner";
import { FILTER_WEBSITE_ENTERTAINMENT }      from "@/constants";
import { useTranslation }                    from 'react-i18next';
import WebsiteEntertainmentModel             from "@/models/services/website/WebsiteEntertainmentModel";
import { Box, createListCollection }         from "@chakra-ui/react";
import useApiCollection                      from "@widesk-core/hooks/useApiCollection";
import useFetch                              from "@widesk-core/hooks/useFetch";
import { getIdFromUrn }                      from "@widesk-core/tools/identifier";
import React                                 from "react";
import { SelectContent }                     from '@/components/ui/select';
import { SelectItem }                        from '@/components/ui/select';
import { SelectRoot }                        from '@/components/ui/select';
import { SelectTrigger }                     from '@/components/ui/select';
import { SelectValueText }                   from '@/components/ui/select';
import StandsListBox                         from "@/pages/Stands/components/StandsListBox";

const StandsPage = () => {

	const { t } = useTranslation();

	const websiteEntertainmentCollection = useApiCollection(WebsiteEntertainmentModel);

	const [selectedWebsiteEntertainment, setSelectedWebsiteEntertainment] = React.useState<WebsiteEntertainmentModel>();

	const { data: websiteEntertainments, isLoading } = useFetch(async () => {

		await websiteEntertainmentCollection.setFilter('websiteEntertainmentStatus', '1').list();

		await websiteEntertainmentCollection.whenIsLoaded(we => we.website);

		const websiteEntertainmentUrn = (localStorage.getItem(FILTER_WEBSITE_ENTERTAINMENT) || '') as Urn;
		const websiteEntertainment = websiteEntertainmentCollection.getById(getIdFromUrn(websiteEntertainmentUrn));

		setSelectedWebsiteEntertainment(websiteEntertainment || websiteEntertainmentCollection.models[0]);

		return websiteEntertainmentCollection.models;
	}, true);

	const filterCollection = createListCollection({
		items: websiteEntertainments?.map(we => {
			return { label: we.label, value: we.urn }
		}) || [],
	});	

	if (isLoading) {
		return <Spinner />
	}

	if (selectedWebsiteEntertainment) {
		return (
				<PageContainer>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="space-between"
					>
						<PageTitle>
							{t('pages.stands.label')}
						</PageTitle>

						<SelectRoot
							bg="white"
							borderRadius="xl"
							collection={filterCollection}
							size="sm"
							width="300px"
							onValueChange={(option) => {
								const value = option.value[0] as Urn;

								localStorage.setItem(FILTER_WEBSITE_ENTERTAINMENT, value);

								const websiteEntertainment = websiteEntertainmentCollection.getById(getIdFromUrn(value)) || undefined;

								setSelectedWebsiteEntertainment(websiteEntertainment);
							}}
							value={[selectedWebsiteEntertainment?.urn]}
						>
							<SelectTrigger>
								<SelectValueText />
							</SelectTrigger>
							<SelectContent>
								{filterCollection.items.map((entertainment) => (
									<SelectItem
										_hover={{ cursor: 'pointer', backgroundColor: '#DEDEDE' }}
										item={entertainment}
										key={entertainment.value}
									>
										{entertainment.label}
									</SelectItem>
								))}
							</SelectContent>
						</SelectRoot>
					</Box>
					<StandsListBox websiteEntertainment={selectedWebsiteEntertainment} />
				</PageContainer>
		);
	}
}

export default StandsPage;